// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/posture/posture.proto" (package "algorithm.posture", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { PostureService } from "./posture";
import type { ReprocessPostureDataResponse } from "./posture";
import type { ReprocessPostureDataRequest } from "./posture";
import type { RestoreReportOrganizationIdRequest } from "./posture";
import type { ListReportsWithoutOrganizationIdResponse } from "./posture";
import type { ListReportsWithoutOrganizationIdRequest } from "./posture";
import type { GetReportTypeByOrganizationIdResponse } from "./posture";
import type { GetReportTypeByOrganizationIdRequest } from "./posture";
import type { AssignReportTypeByOrganizationIdResponse } from "./posture";
import type { AssignReportTypeByOrganizationIdRequest } from "./posture";
import type { ListReportTypesResponse } from "./posture";
import type { ListReportTypesRequest } from "./posture";
import type { GetPresignedPutObjectUrlResponse } from "./posture";
import type { GetPresignedPutObjectUrlRequest } from "./posture";
import type { ListSymptomsResponse } from "./posture";
import type { Empty } from "../../google/protobuf/empty";
import type { GetLicenseInfoByOrganizationIdAndClientResponse } from "./posture";
import type { GetLicenseInfoByOrganizationIdAndClientRequest } from "./posture";
import type { GetLicenseInfoByAccessTokenAndClientResponse } from "./posture";
import type { GetLicenseInfoByAccessTokenAndClientRequest } from "./posture";
import type { GetLicenseInfoByAccountIdAndClientResponse } from "./posture";
import type { GetLicenseInfoByAccountIdAndClientRequest } from "./posture";
import type { GetPostureReportHeaderListResponse } from "./posture";
import type { GetPostureReportHeaderListRequest } from "./posture";
import type { GetLicenseInfoResponse } from "./posture";
import type { GetLicenseInfoRequest } from "./posture";
import type { GetLicenseInfoByAccountIdsResponse } from "./posture";
import type { GetLicenseInfoByAccountIdsRequest } from "./posture";
import type { UpdatePostureReportCoordinateResponse } from "./posture";
import type { UpdatePostureReportCoordinateRequest } from "./posture";
import type { GetMuscleStateResponse } from "./posture";
import type { GetMuscleStateRequest } from "./posture";
import type { IssueAccountLicenseResponse } from "./posture";
import type { IssueAccountLicenseRequest } from "./posture";
import type { IssueOrganizationLicenseResponse } from "./posture";
import type { IssueOrganizationLicenseRequest } from "./posture";
import type { IssueLicenseResponse } from "./posture";
import type { IssueLicenseRequest } from "./posture";
import type { GetRiskDetailByRiskIdsResponse } from "./posture";
import type { GetRiskDetailByRiskIdsRequest } from "./posture";
import type { UploadPostureCallbackResponse } from "./posture";
import type { UploadPostureCallbackRequest } from "./posture";
import type { ReportHeader } from "./posture";
import type { GetReportHeaderRequest } from "./posture";
import type { GetPostureReportListResponse } from "./posture";
import type { GetPostureReportListRequest } from "./posture";
import type { GetPostureReportResponse } from "./posture";
import type { GetPostureReportRequest } from "./posture";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { UploadPostureResponse } from "./posture";
import type { UploadPostureRequest } from "./posture";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service algorithm.posture.PostureService
 */
export interface IPostureServiceClient {
    /**
     * 上传体态图片
     *
     * @generated from protobuf rpc: UploadPosture
     */
    uploadPosture(input: UploadPostureRequest, options?: RpcOptions): UnaryCall<UploadPostureRequest, UploadPostureResponse>;
    /**
     * 获取体态数据
     *
     * @generated from protobuf rpc: GetPostureReport
     */
    getPostureReport(input: GetPostureReportRequest, options?: RpcOptions): UnaryCall<GetPostureReportRequest, GetPostureReportResponse>;
    /**
     * 批量获取体态数据
     *
     * @generated from protobuf rpc: GetPostureReportList
     */
    getPostureReportList(input: GetPostureReportListRequest, options?: RpcOptions): UnaryCall<GetPostureReportListRequest, GetPostureReportListResponse>;
    /**
     * @generated from protobuf rpc: GetReportHeader
     */
    getReportHeader(input: GetReportHeaderRequest, options?: RpcOptions): UnaryCall<GetReportHeaderRequest, ReportHeader>;
    /**
     * 上传体态图片回调
     *
     * @generated from protobuf rpc: UploadPostureCallback
     */
    uploadPostureCallback(input: UploadPostureCallbackRequest, options?: RpcOptions): UnaryCall<UploadPostureCallbackRequest, UploadPostureCallbackResponse>;
    /**
     * 获取风险详情通过风险ids
     *
     * @generated from protobuf rpc: GetRiskDetailByRiskIds
     */
    getRiskDetailByRiskIds(input: GetRiskDetailByRiskIdsRequest, options?: RpcOptions): UnaryCall<GetRiskDetailByRiskIdsRequest, GetRiskDetailByRiskIdsResponse>;
    /**
     * 创建/变动许可证
     *
     * @generated from protobuf rpc: IssueLicense
     */
    issueLicense(input: IssueLicenseRequest, options?: RpcOptions): UnaryCall<IssueLicenseRequest, IssueLicenseResponse>;
    /**
     * 给组织创建许可证，和IssueLicense很像，只是增加client，并且为了和IssueAccountLicense对仗
     *
     * @generated from protobuf rpc: IssueOrganizationLicense
     */
    issueOrganizationLicense(input: IssueOrganizationLicenseRequest, options?: RpcOptions): UnaryCall<IssueOrganizationLicenseRequest, IssueOrganizationLicenseResponse>;
    /**
     * @generated from protobuf rpc: IssueAccountLicense
     */
    issueAccountLicense(input: IssueAccountLicenseRequest, options?: RpcOptions): UnaryCall<IssueAccountLicenseRequest, IssueAccountLicenseResponse>;
    /**
     * 获取肌肉状态
     *
     * @generated from protobuf rpc: GetMuscleState
     */
    getMuscleState(input: GetMuscleStateRequest, options?: RpcOptions): UnaryCall<GetMuscleStateRequest, GetMuscleStateResponse>;
    /**
     * 修改体态坐标点
     *
     * @generated from protobuf rpc: UpdatePostureReportCoordinate
     */
    updatePostureReportCoordinate(input: UpdatePostureReportCoordinateRequest, options?: RpcOptions): UnaryCall<UpdatePostureReportCoordinateRequest, UpdatePostureReportCoordinateResponse>;
    /**
     * @generated from protobuf rpc: GetLicenseInfoByAccountIds
     */
    getLicenseInfoByAccountIds(input: GetLicenseInfoByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByAccountIdsRequest, GetLicenseInfoByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: GetLicenseInfo
     */
    getLicenseInfo(input: GetLicenseInfoRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoRequest, GetLicenseInfoResponse>;
    /**
     * 获取体态数据
     *
     * @generated from protobuf rpc: GetPostureReportHeaderList
     */
    getPostureReportHeaderList(input: GetPostureReportHeaderListRequest, options?: RpcOptions): UnaryCall<GetPostureReportHeaderListRequest, GetPostureReportHeaderListResponse>;
    /**
     * @generated from protobuf rpc: GetLicenseInfoByAccountIdAndClient
     */
    getLicenseInfoByAccountIdAndClient(input: GetLicenseInfoByAccountIdAndClientRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByAccountIdAndClientRequest, GetLicenseInfoByAccountIdAndClientResponse>;
    /**
     * @generated from protobuf rpc: GetLicenseInfoByAccessTokenAndClient
     */
    getLicenseInfoByAccessTokenAndClient(input: GetLicenseInfoByAccessTokenAndClientRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByAccessTokenAndClientRequest, GetLicenseInfoByAccessTokenAndClientResponse>;
    /**
     * @generated from protobuf rpc: GetLicenseInfoByOrganizationIdAndClient
     */
    getLicenseInfoByOrganizationIdAndClient(input: GetLicenseInfoByOrganizationIdAndClientRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByOrganizationIdAndClientRequest, GetLicenseInfoByOrganizationIdAndClientResponse>;
    /**
     * @generated from protobuf rpc: ListSymptoms
     */
    listSymptoms(input: Empty, options?: RpcOptions): UnaryCall<Empty, ListSymptomsResponse>;
    /**
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>;
    /**
     * @generated from protobuf rpc: ListReportTypes
     */
    listReportTypes(input: ListReportTypesRequest, options?: RpcOptions): UnaryCall<ListReportTypesRequest, ListReportTypesResponse>;
    /**
     * @generated from protobuf rpc: AssignReportTypeByOrganizationId
     */
    assignReportTypeByOrganizationId(input: AssignReportTypeByOrganizationIdRequest, options?: RpcOptions): UnaryCall<AssignReportTypeByOrganizationIdRequest, AssignReportTypeByOrganizationIdResponse>;
    /**
     * @generated from protobuf rpc: GetReportTypeByOrganizationId
     */
    getReportTypeByOrganizationId(input: GetReportTypeByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetReportTypeByOrganizationIdRequest, GetReportTypeByOrganizationIdResponse>;
    /**
     * start: 用于获取organization_id为空的数据，以及恢复organization_id的接口，仅用于处理数据异常，不要在任何客户端使用
     *
     * @generated from protobuf rpc: ListReportsWithoutOrganizationId
     */
    listReportsWithoutOrganizationId(input: ListReportsWithoutOrganizationIdRequest, options?: RpcOptions): UnaryCall<ListReportsWithoutOrganizationIdRequest, ListReportsWithoutOrganizationIdResponse>;
    /**
     * end
     *
     * @generated from protobuf rpc: RestoreReportOrganizationId
     */
    restoreReportOrganizationId(input: RestoreReportOrganizationIdRequest, options?: RpcOptions): UnaryCall<RestoreReportOrganizationIdRequest, Empty>;
    /**
     * @generated from protobuf rpc: ReprocessPostureData
     */
    reprocessPostureData(input: ReprocessPostureDataRequest, options?: RpcOptions): UnaryCall<ReprocessPostureDataRequest, ReprocessPostureDataResponse>;
}
/**
 * @generated from protobuf service algorithm.posture.PostureService
 */
export class PostureServiceClient implements IPostureServiceClient, ServiceInfo {
    typeName = PostureService.typeName;
    methods = PostureService.methods;
    options = PostureService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * 上传体态图片
     *
     * @generated from protobuf rpc: UploadPosture
     */
    uploadPosture(input: UploadPostureRequest, options?: RpcOptions): UnaryCall<UploadPostureRequest, UploadPostureResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<UploadPostureRequest, UploadPostureResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取体态数据
     *
     * @generated from protobuf rpc: GetPostureReport
     */
    getPostureReport(input: GetPostureReportRequest, options?: RpcOptions): UnaryCall<GetPostureReportRequest, GetPostureReportResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPostureReportRequest, GetPostureReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 批量获取体态数据
     *
     * @generated from protobuf rpc: GetPostureReportList
     */
    getPostureReportList(input: GetPostureReportListRequest, options?: RpcOptions): UnaryCall<GetPostureReportListRequest, GetPostureReportListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPostureReportListRequest, GetPostureReportListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetReportHeader
     */
    getReportHeader(input: GetReportHeaderRequest, options?: RpcOptions): UnaryCall<GetReportHeaderRequest, ReportHeader> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReportHeaderRequest, ReportHeader>("unary", this._transport, method, opt, input);
    }
    /**
     * 上传体态图片回调
     *
     * @generated from protobuf rpc: UploadPostureCallback
     */
    uploadPostureCallback(input: UploadPostureCallbackRequest, options?: RpcOptions): UnaryCall<UploadPostureCallbackRequest, UploadPostureCallbackResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UploadPostureCallbackRequest, UploadPostureCallbackResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取风险详情通过风险ids
     *
     * @generated from protobuf rpc: GetRiskDetailByRiskIds
     */
    getRiskDetailByRiskIds(input: GetRiskDetailByRiskIdsRequest, options?: RpcOptions): UnaryCall<GetRiskDetailByRiskIdsRequest, GetRiskDetailByRiskIdsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRiskDetailByRiskIdsRequest, GetRiskDetailByRiskIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 创建/变动许可证
     *
     * @generated from protobuf rpc: IssueLicense
     */
    issueLicense(input: IssueLicenseRequest, options?: RpcOptions): UnaryCall<IssueLicenseRequest, IssueLicenseResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<IssueLicenseRequest, IssueLicenseResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 给组织创建许可证，和IssueLicense很像，只是增加client，并且为了和IssueAccountLicense对仗
     *
     * @generated from protobuf rpc: IssueOrganizationLicense
     */
    issueOrganizationLicense(input: IssueOrganizationLicenseRequest, options?: RpcOptions): UnaryCall<IssueOrganizationLicenseRequest, IssueOrganizationLicenseResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<IssueOrganizationLicenseRequest, IssueOrganizationLicenseResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: IssueAccountLicense
     */
    issueAccountLicense(input: IssueAccountLicenseRequest, options?: RpcOptions): UnaryCall<IssueAccountLicenseRequest, IssueAccountLicenseResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<IssueAccountLicenseRequest, IssueAccountLicenseResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取肌肉状态
     *
     * @generated from protobuf rpc: GetMuscleState
     */
    getMuscleState(input: GetMuscleStateRequest, options?: RpcOptions): UnaryCall<GetMuscleStateRequest, GetMuscleStateResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMuscleStateRequest, GetMuscleStateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改体态坐标点
     *
     * @generated from protobuf rpc: UpdatePostureReportCoordinate
     */
    updatePostureReportCoordinate(input: UpdatePostureReportCoordinateRequest, options?: RpcOptions): UnaryCall<UpdatePostureReportCoordinateRequest, UpdatePostureReportCoordinateResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdatePostureReportCoordinateRequest, UpdatePostureReportCoordinateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLicenseInfoByAccountIds
     */
    getLicenseInfoByAccountIds(input: GetLicenseInfoByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByAccountIdsRequest, GetLicenseInfoByAccountIdsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLicenseInfoByAccountIdsRequest, GetLicenseInfoByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLicenseInfo
     */
    getLicenseInfo(input: GetLicenseInfoRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoRequest, GetLicenseInfoResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLicenseInfoRequest, GetLicenseInfoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取体态数据
     *
     * @generated from protobuf rpc: GetPostureReportHeaderList
     */
    getPostureReportHeaderList(input: GetPostureReportHeaderListRequest, options?: RpcOptions): UnaryCall<GetPostureReportHeaderListRequest, GetPostureReportHeaderListResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPostureReportHeaderListRequest, GetPostureReportHeaderListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLicenseInfoByAccountIdAndClient
     */
    getLicenseInfoByAccountIdAndClient(input: GetLicenseInfoByAccountIdAndClientRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByAccountIdAndClientRequest, GetLicenseInfoByAccountIdAndClientResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLicenseInfoByAccountIdAndClientRequest, GetLicenseInfoByAccountIdAndClientResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLicenseInfoByAccessTokenAndClient
     */
    getLicenseInfoByAccessTokenAndClient(input: GetLicenseInfoByAccessTokenAndClientRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByAccessTokenAndClientRequest, GetLicenseInfoByAccessTokenAndClientResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLicenseInfoByAccessTokenAndClientRequest, GetLicenseInfoByAccessTokenAndClientResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLicenseInfoByOrganizationIdAndClient
     */
    getLicenseInfoByOrganizationIdAndClient(input: GetLicenseInfoByOrganizationIdAndClientRequest, options?: RpcOptions): UnaryCall<GetLicenseInfoByOrganizationIdAndClientRequest, GetLicenseInfoByOrganizationIdAndClientResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLicenseInfoByOrganizationIdAndClientRequest, GetLicenseInfoByOrganizationIdAndClientResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListSymptoms
     */
    listSymptoms(input: Empty, options?: RpcOptions): UnaryCall<Empty, ListSymptomsResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, ListSymptomsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListReportTypes
     */
    listReportTypes(input: ListReportTypesRequest, options?: RpcOptions): UnaryCall<ListReportTypesRequest, ListReportTypesResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListReportTypesRequest, ListReportTypesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AssignReportTypeByOrganizationId
     */
    assignReportTypeByOrganizationId(input: AssignReportTypeByOrganizationIdRequest, options?: RpcOptions): UnaryCall<AssignReportTypeByOrganizationIdRequest, AssignReportTypeByOrganizationIdResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<AssignReportTypeByOrganizationIdRequest, AssignReportTypeByOrganizationIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetReportTypeByOrganizationId
     */
    getReportTypeByOrganizationId(input: GetReportTypeByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetReportTypeByOrganizationIdRequest, GetReportTypeByOrganizationIdResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReportTypeByOrganizationIdRequest, GetReportTypeByOrganizationIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * start: 用于获取organization_id为空的数据，以及恢复organization_id的接口，仅用于处理数据异常，不要在任何客户端使用
     *
     * @generated from protobuf rpc: ListReportsWithoutOrganizationId
     */
    listReportsWithoutOrganizationId(input: ListReportsWithoutOrganizationIdRequest, options?: RpcOptions): UnaryCall<ListReportsWithoutOrganizationIdRequest, ListReportsWithoutOrganizationIdResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListReportsWithoutOrganizationIdRequest, ListReportsWithoutOrganizationIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * end
     *
     * @generated from protobuf rpc: RestoreReportOrganizationId
     */
    restoreReportOrganizationId(input: RestoreReportOrganizationIdRequest, options?: RpcOptions): UnaryCall<RestoreReportOrganizationIdRequest, Empty> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<RestoreReportOrganizationIdRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReprocessPostureData
     */
    reprocessPostureData(input: ReprocessPostureDataRequest, options?: RpcOptions): UnaryCall<ReprocessPostureDataRequest, ReprocessPostureDataResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReprocessPostureDataRequest, ReprocessPostureDataResponse>("unary", this._transport, method, opt, input);
    }
}
